/* src/app/webhook-creator/webhook-creator/webhook-form-components/webhook-form-search/webhook-form-search.component.scss */
nz-select {
  width: 100%;
}
.loading-icon {
  margin-right: 8px;
}
/*# sourceMappingURL=webhook-form-search.component.css.map */
